import PostUploadMedia from './post-upload-media';

export default PostUploadMedia;